<template>
  <div class=" items-stretch h-full">

    <div class="flex justify-between w-full">

      <div class="">
        <SelectButton v-model="filter.restaurantPlace"
                      :options="RESTAURANT_PLACES"
                      aria-labelledby="basic"
                      size="small"
                      option-value="value"
                      optionLabel="name"
        />
      </div>

      <div class="flex items-center space-x-2">
        <span class="font-semibold">Od</span>
        <DatePicker v-model="filterDate.from" :disabledDays="[]" size="small" dateFormat="dd.mm.yy" showButtonBar
                    showIcon
                    iconDisplay="input"/>
        <span class="font-semibold">Do</span>
        <DatePicker v-model="filterDate.to" size="small" dateFormat="dd.mm.yy" showButtonBar showIcon
                    iconDisplay="input"/>

        <div class="flex mx-4 items-center">
          <div class="flex  items-center justify-center font-semibold mr-2">
            refresh
          </div>
          <ToggleButton v-model="realTime" :disabled="!isFilterDateToday" onLabel="On" offLabel="Off"/>
        </div>

      </div>

      <Select v-model="filter.status"
              :options="ORDER_STATUS_OPTIONS"
              optionLabel="label"
              optionValue="value"
              placeholder="Stav" class=" w-[240px]"
      />
    </div>

    <hr class="my-4">

    <!--    <pre>-->
    <!--          {{ filter }}-->
    <!--        </pre>-->
    <!--    <pre>-->
    <!--      {{ orders }}-->
    <!--    </pre>-->

    <div v-if="loading" class="text-center py-4">
      Loading ...
    </div>

    <div v-else-if="orders.length === 0" class="text-center py-4">
      Neexistujú žiadne objednávky pre daný filter
    </div>

    <div v-else class="grid grid-cols-3 gap-4">

      <AdminOrder v-for="order in orderedOrders"
                  :key="order.id"
                  :order="order"
      />

    </div>

  </div>

</template>

<script setup>
import MasterLayout from "@/layouts/MasterLayout.vue";
import {ref, onMounted, nextTick, onUnmounted, watch, reactive, computed} from 'vue'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {useRouter} from "vue-router";
import {ROUTE_NAMES} from "@/router";
import Supabase from "@/utils/Supabase";
import {format, parseISO} from 'date-fns';
import useContentStore from "@/stores/contentStore";
import {ORDER_STATUS, ORDER_STATUS_OPTIONS, ORDER_STATUS_PRIORITY, RESTAURANT_PLACES} from "@/content/lists.js";
import AdminOrder from "@/components/views/AdminOrder.vue";
import {startOfDay, endOfDay} from 'date-fns';

const router = useRouter()

const contentStore = useContentStore()

const value = ref('One-Way');
const options = ref(['One-Way', 'Return']);

const filterDate = reactive({
  from: new Date(),
  to: new Date(),
})

const filter = reactive({
  restaurantPlace: RESTAURANT_PLACES[0].value,
  status: -1
})

const realTime = ref(true)

const orders = ref([])

const orderedOrders = computed(() => orders.value.sort((a, b) => {
  // Porovnaj podľa priority statusu
  const statusOrder = ORDER_STATUS_PRIORITY[a.status] - ORDER_STATUS_PRIORITY[b.status];
  // Ak je status rovnaký, porovnaj podľa createdAt (novšie objekty budú vyššie)
  if (statusOrder === 0) return new Date(b.createdAt) - new Date(a.createdAt);
  return statusOrder;
}))

const loading = ref(false)

let realTimeChannel = null
const stopLoadRealTime = () => {
  console.log('stopLoadRealTime')
  if (!realTimeChannel) return
  realTimeChannel.unsubscribe()
  realTimeChannel = null
}

const playOrderSound = () => {
  const audio = new Audio('/order.wav');
  audio.play().catch((e) => {
    console.error('Chyba prehrávania zvuku:', e);
  });
}

const startLoadRealTime = async () => {

  console.log('startLoadRealTime')
  realTimeChannel = Supabase.channel('v2_Hajcer_App_Orders-REAL_TIME')
      .on('postgres_changes', {
            event: 'INSERT',
            schema: 'public',
            table: 'v2_Hajcer_App_App_Orders',
            filter: 'createdAt=gte.' + startOfDay(new Date(filterDate.from)).toISOString(),
          },
          (payload) => {
            console.log('insert App settings changed', payload)
            playOrderSound()
            loadOrders()
          }
      )
      .on('postgres_changes', {
            event: 'UPDATE',
            schema: 'public',
            table: 'v2_Hajcer_App_App_Orders',
            filter: 'createdAt=gte.' + startOfDay(new Date(filterDate.from)).toISOString(),
          },
          (payload) => {
            console.log(' update App settings changed', payload)
            loadOrders()
          }
      )
      .subscribe()

}

const loadOrders = async () => {
  stopLoadRealTime()
  console.log('loadOrders');
  loading.value = true;


  let ordersQuery = Supabase.from('v2_Hajcer_App_App_Orders')
      .select('* , orderItems:v2_Hajcer_App_App_Orders_Items ( * ) ')
      .eq('restaurantPlace', filter.restaurantPlace);

  // Ak je zadaný filter statusu, pridaj ho do dotazu
  if (filter.status !== -1) {
    ordersQuery = ordersQuery.eq('status', filter.status);
  }

  // // Pridanie rozsahu dátumov a zoradenie
  ordersQuery = ordersQuery
      .gte('createdAt', startOfDay(new Date(filterDate.from)).toISOString())
      .lte('createdAt', endOfDay(new Date(filterDate.to)).toISOString())
      .order('createdAt', {ascending: false});

  // Vykonanie dotazu a získanie dát
  const {data, error} = await ordersQuery;

  console.log({data, error});
  if (error) {
    alert('Chyba pri načítaní objednávok');
  } else {
    orders.value = data;
  }

  loading.value = false; // Ukončenie načítavania
  if (isFilterDateToday.value && realTime.value) await startLoadRealTime()
};

const isFilterDateToday = computed(() => {
  const todayStart = startOfDay(new Date()).toISOString()
  const todayEnd = endOfDay(new Date()).toISOString()
  const filterStart = startOfDay(new Date(filterDate.from)).toISOString()
  const filterEnd = endOfDay(new Date(filterDate.to)).toISOString()
  return todayStart === filterStart && todayEnd === filterEnd
})


watch(() => isFilterDateToday.value, (value) => {
  if (!value) realTime.value = false
})
watch(() => filterDate, () => {
  if (!isFilterDateToday.value) filter.realTime = false
  loadOrders()

}, {deep: true})

watch(() => realTime.value, async (value) => {
  if (!value) stopLoadRealTime()
  else if (isFilterDateToday.value) await startLoadRealTime()
})

watch(() => filter, () => {
  loadOrders()
}, {deep: true, immediate: true})

onMounted(() => {
  alert('Uistite sa že máte správne nastavený filter')
})

</script>